import { Card, Stack, Typography, Box } from '@mui/material'
import { useTranslations } from 'next-intl'
import { IconImage } from '@components/common'
import { publicImages } from '@utils/shared'
import { getStyles } from '@utils/styles'
import defaultStyles from './styles'

export function NeedHelpSection() {
  const t = useTranslations('SoultionDetails')
  const styles = getStyles(defaultStyles)

  return (
    <Card {...styles('cardWrapper')}>
      <Stack direction="row" gap="0.5rem" alignItems="center">
        <IconImage src={publicImages.smg} alt="sms" />
        <Typography
          variant="h6.700"
          sx={{
            fontWeight: 800,
          }}
        >
          {t('ReachCostimizer')}
        </Typography>
      </Stack>
      <Box>
        <Typography variant="body2.500" color="text.secondary">
          {t.rich('NeedHelpSection', {
            // eslint-disable-next-line react/no-unstable-nested-components
            PhoneNumber: (children) => (
              <Typography {...styles('needHelpSectionLink')}>
                {children}
              </Typography>
            ),
            // eslint-disable-next-line react/no-unstable-nested-components
            MailLink: (children) => (
              <Typography {...styles('needHelpSectionLink')}>
                {children}
              </Typography>
            ),
          })}
        </Typography>
      </Box>
    </Card>
  )
}
